import { EmailLink } from '@/feature/account/components/email-link/EmailLink.client'

export function AddressEmail({
  email,
  'data-testid': dataTestid,
}: { email: string } & UiComponentProps) {
  return (
    <span data-testid={`${dataTestid}/email`} className="flex gap-1">
      E-mail <EmailLink email={email} withIcon={false} />
    </span>
  )
}
